<template>
  <div>
    <h3 class="checkout-h3 confirmation-subtitle">{{ delivery.name }}</h3>
    <p class="grey--text">{{ delivery.summary }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      delivery: {
        name: 'Checkin Presencial no Evento',
        summary:
          'No dia do evento, apresente seu documento com foto e é só entrar. Boa experiência.',
      },
    };
  },
};
</script>
